import { Commit, Dispatch, Module } from "vuex";
import { RootState } from "@/store";
import { message } from "ant-design-vue";
import { t } from "@/plugins/i18n";
import {
  getOrderAuditList,
  AssessmentReportListParams,
  auditOrder,
  AuditOrderParams,
} from "@/api/userCenter";
import dayjs from "dayjs";

type aduitItem = {
  id: number;
  datasetName: string;
  taskId: number;
  buyerName: string;
  buyerTime: number;
  amount: number;
  auditExpireTime: number;
  auditState: 0 | 1;
};
interface State {
  auditList: aduitItem[];
  auditListPage: {
    pageNo: number;
    pageSize: number;
    totalPage: number;
  };
}

const store: Module<State, RootState> = {
  namespaced: true, // 为每个模块添加一个前缀名，保证模块命明不冲突
  state: () => {
    return {
      auditList: [],
      auditListPage: {
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
      },
    };
  },
  mutations: {
    setAuditList(state: State, payload) {
      const { data: list, page } = payload || {
        data: [],
        page: { count: 0 },
      };
      state.auditList = list.map((item: aduitItem) => {
        return {
          ...item,
          buyerTime: dayjs(item.buyerTime * 1000).format("YYYY/MM/DD HH:mm:ss"),
          auditExpireTime: dayjs(item.auditExpireTime * 1000).format(
            "YYYY/MM/DD HH:mm:ss"
          ),
        };
      });
      state.auditListPage = page;
    },
  },
  actions: {
    async getAuditList(
      { commit }: { commit: Commit },
      params: AssessmentReportListParams = {}
    ) {
      try {
        const res = await getOrderAuditList(params);
        commit("setAuditList", res);
      } catch (error) {
        log.error(error, "error");
      }
    },
    async orderAudit(
      {
        commit,
        dispatch,
        state,
      }: { commit: Commit; dispatch: Dispatch; state: State },
      params: AuditOrderParams
    ) {
      try {
        console.log("params:", params);
        await auditOrder(params);
        dispatch("getAuditList", {
          pageNo: state.auditListPage.pageNo,
          pageSize: state.auditListPage.pageSize,
        });
        message.success(
          t(
            params.auditState === 1
              ? "userCenter.auditSuccess2"
              : "userCenter.rejectSuccess"
          )
        );
      } catch (error) {
        log.error(error, "error");
        message.error(t("userCenter.auditFail"));
      }
    },
  },
};

export default store;
